import { useTranslation } from 'react-i18next';
import { ja, enUS } from 'date-fns/locale';

const localeMap = { ja, en: enUS } as const;

export const useDateLocale = () => {
  const { i18n } = useTranslation();
  return localeMap[i18n.language as keyof typeof localeMap] ?? ja;
};

export const getDateLocale = () => {
  const lang = (typeof window !== 'undefined' && localStorage.getItem('i18n_language')) || 'ja';
  return lang === 'en' ? enUS : ja;
};

export const getIntlLocale = () => {
  const lang = (typeof window !== 'undefined' && localStorage.getItem('i18n_language')) || 'ja';
  return lang === 'en' ? 'en-US' : 'ja-JP';
};
